import {
  Button,
  Navbar,
  Container,
  NavDropdown,
  Nav,
  NavItem,
} from "react-bootstrap";

import Months from "./components/months/Months";
import Shop from "./components/shop/Shop";
import Info from "./components/Info";
import React, { useEffect, useState } from "react";
import { useAuthState } from "react-firebase-hooks/auth";
import { useNavigate } from "react-router-dom";
import { auth, db, logout } from "./firebase";
import { query, collection, getDocs, where } from "firebase/firestore";

export default function TempIndex() {
  const [isMonthly, setMonthly] = useState(false);
  const [isShop, setShop] = useState(false);
  const [isInfo, setInfo] = useState(false);

  const [user, loading, error] = useAuthState(auth);
  const navigate = useNavigate();

  // useEffect(() => {
  //   if (loading) return;
  //   if (!user) return navigate("/public");
  //   // fetchUserName();
  // }, [user, loading]);

  function handleMonthly() {
    setMonthly(true);
    setShop(false);
    setInfo(false);
  }

  function handleShop() {
    setMonthly(false);
    setShop(true);
    setInfo(false);
  }

  function handleInfo() {
    setMonthly(false);
    setShop(false);
    setInfo(true);
    navigate("/software");
  }

  function handleHome() {
    setMonthly(false);
    setShop(false);
    setInfo(false);
  }

  return (
    <>
      <Navbar collapseOnSelect expand="lg" bg="dark" variant="dark">
        <Container>
          <Navbar.Brand onClick={() => handleHome()}>aidinalev</Navbar.Brand>
          <Navbar.Toggle aria-controls="responsive-navbar-nav" />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav className="me-auto">
              {user && (
                <Nav.Link onClick={() => handleMonthly()}>agro</Nav.Link>
              )}
              {user && <Nav.Link onClick={() => handleShop()}>ideas</Nav.Link>}

              {/* <NavDropdown title="Dropdown" id="collasible-nav-dropdown">
              <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
              <NavDropdown.Item href="#action/3.2">
                Another action
              </NavDropdown.Item>
              <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="#action/3.4">
                Separated link
              </NavDropdown.Item>
            </NavDropdown> */}
            </Nav>
            <Nav>
              <Nav.Link onClick={() => handleInfo()}>software</Nav.Link>
              {user && <Nav.Link onClick={logout}>logout</Nav.Link>}
              {!user && (
                <Nav.Link onClick={() => navigate("/admin")}>admin</Nav.Link>
              )}
              {/* <Nav.Link onClick={logout}>logout</Nav.Link> */}
              {/* <Nav.Link eventKey={2} href="#memes">
              Dank memes
            </Nav.Link> */}
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      {isMonthly ? <Months> </Months> : <h2></h2>}
      {isShop ? <Shop> </Shop> : <h2></h2>}
      {isInfo ? <Info> </Info> : <h2></h2>}
    </>
  );
}
